<template>
  <div class="customerBox">
    <div v-if="isWeChat">
      <browser-open></browser-open>
    </div>
    <div v-else>
      <div class="nav">
        <!-- <img src="/rechargeImg/back.png" alt="" />
        <span class="title">充值</span> -->
      </div>
      <div style="background:#fff;padding-bottom:30px">
        <div class="rechargeTip">
          <div class="left">
            <img :src="userAvatarImg" alt="" />
            <div class="userInfo">
              <div class="userNameBox">
                <div class="userName">{{userName}}</div>
              </div>
              <div class="userId"> {{userCode? 'ID:' +  userCode : ''}}</div>
            </div>
          </div>
          <div class="right">
            <div class="buttonBox" v-if="showLoginBtn" @click="showLogin= true">登录</div>
            <div class="buttonBox buttonBox1" v-else @click="loginOut">切换用户</div>
          </div>
        </div>
      </div>
      <div class="moneyBox">
        <div class="list">
          <div class="item" :class="chooseJson.pid == item.pid ? 'active' : ''" v-for="item in list" :key="item.pid" @click="chooseClick(item)">
            <div class="text">
              <span>{{ toFixed(item.diamond, 0) }}</span>
              <img src="/rechargeImg/zs.png" alt="" />
            </div>
            <div class="price">
              <span>¥{{ toFixed(item.money, 1) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%;height: 240px;"></div>
      <div class="payType">
        <!-- <div class="list">
          <div class="left">
            <img src="/rechargeImg/zfb.png" alt="" />
            <span>支付宝</span>
          </div>
          <div class="right">
            <img @click="payTypeClick(1001)" :src="payType == 1001 ? '/rechargeImg/select_active.png' : '/rechargeImg/select.png'" alt="" />
          </div>
        </div>
        <div class="list">
          <div class="left">
            <img src="/rechargeImg/wx.png" alt="" />
            <span>微信支付</span>
          </div>
          <div class="right">
            <img @click="payTypeClick(1002)" :src="payType == 1002 ? '/rechargeImg/select_active.png' : '/rechargeImg/select.png'" alt="" />
          </div>
        </div> -->
        <div class="totalPrice">
          <div class="top">
            <div class="left">共计：¥{{ toFixed(chooseJson.money, 1) }}</div>
            <div class="right" @click="rechargeSubmit">立即购买</div>
          </div>
          <div class="bottom"><img @click="agreementClick" :src="agreementFlag ? '/rechargeImg/select_active.png' : '/rechargeImg/select.png'" alt="" /><span>充值即代表同意</span><span @click="toOpenAgreement" style="color: #2a2a2a">《小麦语音支付协议》</span></div>
          <div class="bottomText">充值的钻石，可登录小麦语音APP进行确认查收</div>
        </div>
      </div>
      <div class="login" v-if="showLogin">
        <div class="loginInput">
          <div class="title">请登录小麦语音账号</div>
          <div class="inputTop">
            <div class="topInputLeft">
              +86
            </div>
            <div class="topInputRight">
              <input class="inputBox" v-model="phone" maxlength="11" @input="phoneNumInput($event)" placeholder="请输入手机号"/>
            </div>
          </div>
          <div class="inputBottom">
            <input class="inputBox" v-model="verificationCode" maxlength="6" @input="codeInput($event)" placeholder="请输入验证码"/>
            <div class="verificationCodeButton" v-if="isGetSmsCode" @click="sendSmsCode">{{sendSmsCodeText}}</div>
            <div class="verificationCodeButton clickSendSmsCode" v-else>{{getSmsCodeTime}}s</div>
          </div>
          <div class="loginbutton" :class="{noClickSendSmsCode: noClickGetSmsCode}" @click="smsCodeLogin">
            登录
          </div>
          <div class="clearbtn">
            <img src="/rechargeImg/clear.png" alt="" @click="clearLogin">
          </div>
        </div>
      </div>
      <div class="login" v-if="showPopUp">
        <div class="popUpWindow">
          <div class="title">提示</div>
          <div class="msgBox" v-if="showPopUpType">{{ showPopUpMsg }}</div>
          <div class="msgBox" v-else>
            <div style="line-height: 22px;">该账户尚未实名</div>
            <div style="line-height: 22px;">请前往APP完成实名</div>
          </div>
          <div class="confirmBtn" @click="clearPopUp">确定</div>
        </div>
      </div>
      <Toast ref="toast"></Toast>
    </div>
  </div>
</template>

<script>
import { getDiamond,getSmsCode,smsCodeLogin,getUserInfo,createdRecord,payDiamond,loginOut ,checkUser} from '../../api/pay'
import {isWeChatBrowser} from '../../config/utils'
import BrowserOpen from './browserOpen.vue'
import Toast from '../../components/toast.vue'
export default {
  name: 'customerRecharge',
  components: { BrowserOpen,Toast },
  data() {
    return {
      isWeChat: isWeChatBrowser(),
      payType: 1004,
      agreementFlag: false,
      diamond: 0,
      chooseJson: {
        pid: '',
        diamond: 0,
        money: '0.0',
      },
      defaultList: [{
           "money":"6.00",
           "diamond":"600.00"
        },
        {
           "money":"18.00",
           "diamond":"1800.00"
        },
        {
           "money":"30.00",
           "diamond":"3000.00"
        },
        {
           "money":"50.00",
           "diamond":"5000.00"
        },
        {
           "money":"68.00",
           "diamond":"6800.00"
        },
        {
           "money":"80.00",
           "diamond":"8000.00"
        },
        {
           "money":"98.00",
           "diamond":"9800.00"
        },
        {
           "money":"200.00",
           "diamond":"20000.00"
        },
        {
           "money":"288.00",
           "diamond":"28800.00"
        },
        {
           "money":"328.00",
           "diamond":"32800.00"
        },
        {
           "money":"388.00",
           "diamond":"38800.00"
        },
        {
           "money":"588.00",
           "diamond":"58800.00"
        },
        {
           "money":"648.00",
           "diamond":"64800.00"
        },
        {
           "money":"1000.00",
           "diamond":"100000.00"
        }],
      openId: this.$route.query.wxid,
      // openId: '031DM2Ga1loFoG0MLuIa1smTnv4DM2GB',
      userName: '',
      userId: '',
      userCode: '', //负责展示的ID
      userAvatarImg: '/rechargeImg/defaultAvatar.png', // 用户头像
      list: [], //钻石商品列表
      phone: '', // 手机号
      loginPhone: '', // 登录成功的人的手机号
      verificationCode: '', //验证码
      showPopUp: false, //错误弹窗
      showPopUpMsg: '',// 错误弹窗消息
      showLogin: false, // 展示登录框
      showLoginBtn: true, // 展示登录按钮
      isGetSmsCode: true, // 是否点击获取验证码
      noClickGetSmsCode: true, // 是否点击过获取验证码用于提示请发送验证码,此状态只记录一次,true
      getSmsCodeTime: 60, // 获取验证码时间
      timer:'', // 时间定时器
      sendSmsCodeText: '发送验证码',
      showPopUpType: true, //判断是不是实名提示错误
    }
  },
  mounted() {
    console.log(navigator);
    var p = navigator.platform;
    if((p.indexOf("Win")==0||p.indexOf("Mac")==0||(p=="X11")) || !(/Android|iPhone/i.test(navigator.userAgent))){
      this.clearWindow()
    }
    let isOnIPhone = navigator.userAgent.indexOf('iPhone') == '-1'
    this.list = this.defaultList
    if (sessionStorage.getItem('openAlipay') && isOnIPhone ) {
      this.setUserInfo()
      this.showLoginBtn = false
      sessionStorage.setItem('openAlipay',0)
      this.showPopUp= true;
      this.showPopUpMsg= '请前往APP查看充值记录'
    }
    if (sessionStorage.getItem('otherUser')) {
      this.showLogin = true
      sessionStorage.removeItem('otherUser',0)
    }
  },
  methods: {
    agreementClick() {
      this.agreementFlag = !this.agreementFlag
    },
    // payTypeClick(type) {
    //   this.payType = type
    // },
    createNonceStr(){
      let chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
      let nums="";
      for(let i=0;i<16;i++){//这里是几位就要在这里不改变
      let id = parseInt(Math.random()*61);
      nums+=chars[id];
      }
      return nums;
    },
    chooseClick(item) {
      if (item.pid == undefined) {
        item.pid = this.createNonceStr()
        this.chooseJson.pid = this.createNonceStr()
      }
      this.chooseJson = item
    },
    toFixed(num, type) {
      // console.log(num)
      return parseFloat(num).toFixed(type)
    },
    getList() {
      getDiamond().then((result) => {
        if (result.code == 200) {
          this.list = result.data.list
          sessionStorage.setItem('list',JSON.stringify(this.list))
        }
      })
    },
    // 发送验证码
    sendSmsCode() {
      if (this.phoneVerify(this.phone)) {
        ///先校验openid正确性
          checkUser({openId:this.openId,checkType:1}).then(res=>{
            if(res.data){
              
                  this.isGetSmsCode = false
                  this.noClickGetSmsCode= false
                  const that = this
                  this.timer = setInterval(()=> {
                    that.getSmsCodeTime= that.getSmsCodeTime - 1
                    if (that.getSmsCodeTime == 0) {
                      this.isGetSmsCode = true
                      that.sendSmsCodeText = '重新发送'
                      clearInterval(this.timer)
                      this.getSmsCodeTime= 60
                    }
                  },1000)
                  let params = {
                    phone: this.phone,
                    smsType: 2,
                    areaCode: 86
                  }
                  getSmsCode(params).then(res => {
                  })
              
            }else{
              this.$refs.toast.showToast(res.msg)
            }
          }).catch(err=>{
            this.$refs.toast.showToast('服务器错误请重试')
          })

      }
    },
    //手机号校验
    phoneVerify(phone) {
      if (phone) {
        let chinaPhoneRegex = /^1\d{10}$/;
        if (chinaPhoneRegex.test(phone)) {
          return true
        } else {
          this.$refs.toast.showToast('手机号格式不正确')
          return false
        }
      } else {
        this.$refs.toast.showToast('请输入手机号')
        return false
      }
    },
    // 验证码校验
    smsCodeVerify(smsCode) {
      if (smsCode) {
        let sixDigitCodeRegex = /^\d{6}$/;
        if (sixDigitCodeRegex.test(smsCode)) {
          return true
        } else {
          this.$refs.toast.showToast('验证码格式不正确')
          return false
        }
      } else {
        this.$refs.toast.showToast('请输入验证码')
        return false
      }
    },
    // 登录 
    smsCodeLogin() {
      if (this.phoneVerify(this.phone) && this.smsCodeVerify(this.verificationCode)) {
        if (this.noClickGetSmsCode) {
          this.$refs.toast.showToast('请发送验证码')
          return
        }
        checkUser({openId:this.openId,checkType:2}).then(res=>{
           if(res.data){
           
          
          
            let params = {
              phone: this.phone,
              smsCode: this.verificationCode,
              areaCode: '86'
            }
            smsCodeLogin(params).then(res => {
              this.getSmsCodeTime= 60
              this.isGetSmsCode = true
              this.sendSmsCodeText = '发送验证码'
              this.showPopUpType= true
              clearInterval(this.timer)
              if (res.code == 200) {
                let token = res.data.token
                sessionStorage.setItem('token',token)
                this.loginPhone = this.phone
                this.userId = res.data.userId
                this.getUersInfoById(this.userId)
                this.getList()
                // 登录成功后
                this.showLogin = false
                this.phone= ''
                this.verificationCode=''
                this.smsCode = ''
                this.showLoginBtn = false
              } else if(res.code == 20030) {
                this.smsCode = ''
                this.phone= ''
                this.verificationCode=''
                this.showLogin = false;
                this.showPopUp= true;
                this.showPopUpType= false
              } else {
                this.smsCode = ''
                this.phone= ''
                this.verificationCode=''
                this.showLogin = false;
                this.showPopUp= true;
                this.showPopUpMsg= res.msg
              }
            })
          }else{
  
              this.$refs.toast.showToast(res.msg)
           
          }
        }).catch(err=>{
          this.$refs.toast.showToast('服务器错误请重试')
        })
      }
    },
    // 关闭登录
    clearLogin() {
      this.phone= ''
      this.verificationCode=''
      this.showLogin = false
    },
    // 弹窗确认
    clearPopUp() {
      this.showPopUp= false;
    },

    // 获取用户信息
    getUersInfoById(id){
      let params = {
        uid: id
      }
      getUserInfo(params).then(res => {
        if (res.code == 200) {
          this.userAvatarImg = res.data.avatarImg
          this.userName = res.data.alias
          this.userCode = res.data.userCode
          this.setStorageLoginInfo()
        }
      })
    },
    // 退出登录
    loginOut() {
      loginOut().then(res=>{
        if (res.code == 200 ) {
          sessionStorage.setItem('otherUser',1)
          this.clearStorageLoginInfo()
          setTimeout(() => {
            window.location.reload()
            // clearTimeout(timer)
          }, 100);
        }
      })
    },
    //   充值
    async rechargeSubmit() {
      if (!sessionStorage.getItem('token')) {
        this.$refs.toast.showToast('请先登录')
        this.showLogin = true
        return
      }
      if (this.agreementFlag) {
        if (this.chooseJson.pid != '') {
          let createdRecordParams = {
            openId : this.openId,
            phone: this.loginPhone,
            amount: this.chooseJson.money,
            uid: this.userId,
            checkType:3,
          }
          console.log(createdRecordParams)
          let isAllow = true
          let isAllowMsg = ''
          let isCode = ''
          let res = await checkUser(createdRecordParams).then(res=>{
            isAllow = res.data;
            isCode = res.code;
            isAllowMsg = res.msg
          }).catch(error=>{
            isAllow = false;
            isAllowMsg = '服务器错误请重试'
          })
       
          if(!isAllow||(isCode!=200&&isAllow!=403)){
            this.$refs.toast.showToast(isAllowMsg)
            return
          }
          if (isCode == 402) {
            this.$refs.toast.showToast('身份过期请重新登录')
            this.loginOut()
            return
          }
          let params = {
            pid: this.chooseJson.pid,
            payChannel: 1004,
            payDevice: 4
          }
          if (isCode == 200) {
            payDiamond(params).then(response=> {
              if(response.code == 200) {
                sessionStorage.setItem('openAlipay',1)
                const that = this
                let resData = response.data.diamond
                const div = document.createElement('div')
                div.id = 'alipay'
                div.innerHTML = resData
                document.body.appendChild(div)
                document.querySelector('#alipay').children[0].submit() // 执行后会唤起支付宝
                setTimeout(()=>{
                  that.showPopUp= true;
                  that.showPopUpMsg= '请前往APP查看充值记录'
                  document.querySelector('#alipay').remove()
                },3000)
              }
            })
          }
        } else {
          this.$refs.toast.showToast('请选择充值钻石数量')
        }
      } else {
        this.$refs.toast.showToast('请阅读并勾选协议')
      }
    },
    // 小麦语音充值协议
    toOpenAgreement(){
      // window.webkit.messageHandlers.openWebView.postMessage(JSON.stringify({url: 'https://croaker.mokayuyin.com/usAgreement?code=PAY_AGREEMENT'}))
      let environmentUrl = window.location.href.indexOf('croaker.xiaomaiyuyin.com') != -1
      if(environmentUrl) {
        window.open('https://croaker.xiaomaiyuyin.com/usAgreement?code=PAY_AGREEMENT')
      }else {
        window.open('https://croaker.mokayuyin.com/usAgreement?code=PAY_AGREEMENT')
      }
    },
    // 设置用户信息
    setUserInfo(){
      this.loginPhone = sessionStorage.getItem('loginPhone')
      this.userId = sessionStorage.getItem('userId')
      this.userCode = sessionStorage.getItem('userCode')
      this.userName = sessionStorage.getItem('userName')
      this.userAvatarImg = sessionStorage.getItem('userAvatarImg')
      this.list = JSON.parse(sessionStorage.getItem('list'))
    },
    // 保存用户信息
    setStorageLoginInfo() {
      sessionStorage.setItem('loginPhone',this.loginPhone)
      sessionStorage.setItem('userId',this.userId)
      sessionStorage.setItem('userCode',this.userCode)
      sessionStorage.setItem('userName',this.userName)
      sessionStorage.setItem('userAvatarImg',this.userAvatarImg)
    },
    //清空用户信息
    clearStorageLoginInfo(){
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('loginPhone')
      sessionStorage.removeItem('userId')
      sessionStorage.removeItem('userCode')
      sessionStorage.removeItem('userName')
      sessionStorage.removeItem('userAvatarImg')
      sessionStorage.removeItem('openAlipay')
      sessionStorage.removeItem('list')
    },
    // 验证码输入长度校验
    codeInput(event) {
      let inputValue = event.target.value;
      // 使用正则表达式检查是否为数字
      if (!/^\d*$/.test(inputValue)) {
          // 如果不是数字，清除非数字字符
          event.target.value = inputValue.replace(/\D/g, '');
      }
      // 限制最大长度为6
      if (inputValue.length > 6) {
          event.target.value = inputValue.slice(0, 6);
      }
    },
    // 手机号长度校验
    phoneNumInput(event) {
      let inputValue = event.target.value;
      // 使用正则表达式检查是否为数字
      if (!/^\d*$/.test(inputValue)) {
          // 如果不是数字，清除非数字字符
          event.target.value = inputValue.replace(/\D/g, '');
      }
      // 限制最大长度为6
      if (inputValue.length > 6) {
          event.target.value = inputValue.slice(0, 11);
      }
    },
    // 清空页面
    clearWindow() {
      //删除app元素,也就是vue的挂载元素.用于禁止pc端浏览打开
      let app = document.getElementById("app");
      if (app) {
        app.remove()
      }
      document.write('请用手机浏览器打开');
    }
  },
}
</script>

<style lang="less" scoped>
.customerBox {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(345deg, #ffffff 0%, #e6deee 68%, #fffec3 100%, #e9ffaa 43%);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  .nav {
    height: 50px;
    background: #fff;
  }
  .rechargeTip {
    display: flex;
    justify-content: space-between;
    margin-top: 100px;
    width: 94%;
    margin: 0 auto;
    border-radius: 7px;
    .left {
      display: flex;
      justify-content: start;
      width: 70%;
      height: 100%;
      img {
        width: 48px;
        height: 48px;
        margin-right: 4%;
        border-radius: 50%;
      }
      .userInfo {
        .userNameBox{
          width: 44vw;
          .userName {     
            width: 100%;     
            font-size: 18px;
            white-space: nowrap;
            word-break: keep-all;
            overflow:hidden;
            text-overflow: ellipsis;
            margin: 5px 0 12px 0;
          }
        }
        .userId {
          color: #666666;
          font-size: 14px;
        }
      }
    }
    .right {
      float: right;
      width: 30%;
      margin-right: 15px;
      margin-top: 10px;
      text-align: center;
      height: 100%;
      line-height: 30px;
      color: #A7A7A7 100%;
      font-weight: 900;
      .buttonBox {
        width: 100%;
        height: 100%;
        font-size: 13px;
        background: #F8F8F8;
        color: #A7A7A7;
        border-radius: 15px 15px 15px 15px;
      }
      .buttonBox1 {
        background: #F8F8F8;
        border: 1px solid #A7A7A7;
        border-radius: 15px 15px 15px 15px;
      }
    }
  }
  .moneyBox {
    width: 94%;
    height: auto;
    margin: 30px auto;
    .title {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #000000;
      font-weight: bold;
    }

    .list {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: space-between;
      .item {
        width: 32%;
        height: 100px;
        background: #fff;
        margin-bottom: 15px;
        border: 5px solid #fff;
        border-radius: 10px;
        margin-right: 2%;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .text {
          width: 100%;
          height: 40px;
          line-height: 40px;
          font-weight: 900;
          text-align: center;
          font-size: 18px;
          margin-top: 10px;
          img {
            display: inline-block;
            width: 20px;
            vertical-align: inherit;
            margin-left: 5px;
          }
        }
        .price {
          width: 100%;
          text-align: center;
          height: 20px;
          line-height: 20px;
          font-weight: 600;
          font-size: 18px;
        }
      }
      .active {
        border: 5px solid #fceab9;
      }
    }
  }

  .payType {
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    width: 100%;
    height: auto;
    .list {
      width: 100%;
      height: 70px;
      line-height: 70px;
      border-bottom: 1px solid #e2e2e2;
      .left {
        float: left;
        width: 70%;
        height: 100%;
        font-weight: 600;
        img {
          float: left;
          width: 20px;
          margin: 26px;
          margin-right: 10px;
          margin-left: 15px;
        }
      }
      .right {
        float: right;
        width: 20%;
        height: 100%;
        img {
          float: right;
          margin-right: 15px;
          width: 20px;
          margin-top: 25px;
        }
      }
    }
    .totalPrice {
      width: 100%;
      height: 120px;
      .top {
        width: 100%;
        height: 60px;
        line-height: 60px;
        .left {
          float: left;
          width: 60%;
          height: 100%;
          margin-left: 15px;
          font-weight: 600;
          font-size: 18px;
        }
        .right {
          float: right;
          width: 84px;
          height: 35px;
          margin: 10px;
          margin-right: 15px;
          background-color: #f9eb34;
          text-align: center;
          line-height: 40px;
          color: #000000;
          border-radius: 1000px;
        }
      }
      .bottom {
        width: 100%;
        height: 30px;
        line-height: 30px;
        margin-left: 15px;
        font-size: 12px;
        span {
          color: #d2d2d2;
        }
        img {
          display: inline-block;
          width: 15px;
          vertical-align: middle;
          margin-right: 5px;
        }
      }
      .bottomText{
        margin-left: 15px;
        font-size: 11px;
        line-height: 20px;
        color: #666;
      }
    }
  }
  .login {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    .loginInput {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%,-50%);
      padding: 22px;
      width: 80%;
      height: 254px;
      background: #fff;
      border-radius: 20px 20px 20px 20px;
      .title {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .inputTop{
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        width: 100%;
        height: 46px;
        .topInputLeft{
          width: 19%;
          height: 100%;
          border-radius: 27px 0 0 27px;
          background: #F2F2F2;
          line-height: 46px;
          text-align: center;
          font-weight: 600;
          color: #373737;
        }
        .topInputRight{
          padding: 14px;
          width: 79%;
          height: 100%;
          border-radius: 0 27px 27px 0;
          background: #F2F2F2;
          font-weight: 600;
          color: #373737;
          input {
            background: none;
            outline: none;
            border: 0px;
          }
          input:focus{
            outline:none
          }
        }
      }
      .inputBottom {
        position: relative;
        padding: 14px;
        width: 100%;
        height: 46px;
        background: #F2F2F2;
        border-radius: 27px;
        input {
          background: none;
          outline: none;
          border: 0px;
        }
        input:focus{
          outline:none
        }
        .verificationCodeButton {
          position: absolute;
          top: 50%;
          right: 2%;
          transform: translate(0,-50%);
          width: 77px;
          height: 33px;
          border-radius: 27px;
          background: #F9EB34;
          text-align: center;
          font-size: 13px;
          line-height: 33px;
          color: #373737;
        }
        .clickSendSmsCode {
          border: 1px solid #A7A7A7;
          background: none;
        }
      }
      .loginbutton {
        width: 100%;
        height: 46px;
        background: #F9EB34;
        margin-top: 25px;
        text-align: center;
        font-size: 13px;
        line-height: 46px;
        border-radius: 27px;
      }
      .noClickSendSmsCode {
        background: rgba(249, 235, 52, 0.6);
      }
    }
    .clearbtn{
      position: absolute;
      bottom: -100px;
      left: 50%;
      transform: translate(-50%, 0);
      width: 30px;
      height: 30px;
      margin: 25px auto;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .popUpWindow {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    padding: 22px;
    width: 80%;
    height: 254px;
    background: #fff;
    border-radius: 20px 20px 20px 20px;
      .title {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 20px;
        color: #373737;
        text-align: center;
      }
      .msgBox{
        line-height: 46px;
        font-size: 18px;
        text-align: center;
        height: 102px;
        font-weight: 500;
        color: #666666;
      }
      .confirmBtn {
        width: 100%;
        height: 46px;
        margin-top: 20px;
        background: #F9EB34;
        text-align: center;
        font-size: 13px;
        line-height: 46px;
        border-radius: 27px;
      }
  }
}
</style>
